"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputCSS = void 0;

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var InputSizesCSS_1 = require("./InputSizesCSS");

var InputStatesCSS_1 = require("./InputStatesCSS");

var theme_1 = require("../theme");

var react_input_mask_1 = __importDefault(require("react-input-mask"));

exports.InputCSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: 0.8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  &::placeholder {\n    color: ", ";\n  }\n  &[type=\"checkbox\"] {\n    margin: 0;\n    padding: 0;\n    max-height: 18px;\n    max-width: 18px;\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.width || "100%";
}, theme_1.theme.colors.white[500], theme_1.theme.colors.gray[800], InputStatesCSS_1.InputStatesCSS, InputSizesCSS_1.InputSizesCSS);
var StyledInput = styled_components_1.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), exports.InputCSS);

var Input = function Input(_ref) {
  var mask = _ref.mask,
      props = _objectWithoutProperties(_ref, ["mask"]);

  if (mask) {
    return react_1.default.createElement(react_input_mask_1.default, _objectSpread({
      mask: mask,
      maskChar: null
    }, props), function (inputProps) {
      return react_1.default.createElement(StyledInput, _objectSpread({}, inputProps));
    });
  }

  return react_1.default.createElement(StyledInput, _objectSpread({}, props));
};

exports.Input = Input;